import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as pastProductsForSomeoneElseState from '../employee-detail.reducer';
import * as pastProductsForSomeoneElseReducer from '../reducers/past-products-for-someone-else.reducer';

export const getPastProductsForSomeoneElse = createSelector(
  pastProductsForSomeoneElseState.getPastProductsForSomeoneElseState,
  pastProductsForSomeoneElseReducer.getPastProductsForSomeoneElseResponse
);
